export default {
  socialIconSize: '48px',
  commonIconSize: '44px',
  avatarSize: '200px',
  avatarSizeMobile: '142px',
  avatarSmallSize: '40px',
  productSize: '104px',
  productSizeMobile: '164px',
  productSizeBig: '184px',
  productSizeDetail: '400px',
  productSizeCart: '73px',
  productSizeHighlight: '82px',
  coverSize: '224px',
  coverSizeMobile: '155px',
  coverSizeHighlight: '136px',
  coverSizeHighlightMobile: '188px',
  coverSizeRounded: '200px',
  coverSizeRoundedMobile: '130px',
  coverSizeSmall: '48px',
};
